import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

/**
 * React Query mutation hook for updating candidate status
 *
 * @param {Object} [options] - Hook options
 * @param {(variables: import('../types/UpdateCandidateStatus.parameters').IUpdateCandidateStatusPayload) => void} [options.onSuccess] - Success callback
 * @param {(error: Error) => void} [options.onError] - Error callback
 */
export const useUpdateCandidateStatus = (options = {}) => {
  const { onSuccess, onError } = options;

  const mutation = useMutation({
    mutationFn: async ({ candidateIds, status }) => {
      await PermanentJobsService.updateCandidateStatus({ candidateIds, status });
    },
    onSuccess: (_, variables) => {
      if (onSuccess) {
        onSuccess(variables);
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return mutation;
};
